<template>
	<div class="TypeShowHow">
		<!-- 面包屑 -->
		<div class="Breadcrumb">
			<img src="~@img/icon/ui_home_page_0.png" alt />
			<a @click="$router.push('/Layout/Home')">首页 &nbsp;/ &nbsp;</a>
			<a class="active">演示模式</a>
		</div>
		<!-- 内容 -->
		<div class="contain">
			<div style="width: 65%">
				<div class="containl">
					<video id="video1" controls :src="videoinfo.video" :disablePictureInPicture="true"></video>
				</div>
				<h1 class="title" style="margin-top: 20px">{{videoinfo.name}}</h1>
				<p class="desc">{{videoinfo.profile}}</p>
			</div>
			<div class="sidearea" style="width: 30%">
				<div style="min-height:151px">
					<p class="title">{{videoinfo.name?videoinfo.name:'暂无视频'}}</p>
					<p class="titledesc">{{videoinfo.profile}}</p>
				</div>
				<div style="overflow:hidden;padding-bottom:20px">
					<p class="title">分集</p>
					<div class="videoList">
						<!-- <p class="chapter" :class="isfull? 'active':''" @click="isfull=true,videoinfo=videofull">
							<img v-show="isfull" src="~@img/icon/ui_play_y.png" alt />
							{{videofull.name}}
						</p> -->
						<p class="chapter" :class="!isfull&&item.videoId===videoinfo.videoId?'active':''" v-for="(item,index) in videolist" :key="index" @click="toplay(item)">
							<img v-show="!isfull&&item.videoId===videoinfo.videoId" src="~@img/icon/ui_play_y.png" alt />
							{{item.name}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "TypeShowHow",
	data() {
		return {
			isfull: false,
			videoinfo: {
				video: undefined,
			},
			videolist: [], //视频子集
			videofull: {}, //总视频
		};
	},
	mounted() {
		this.getVideos();
	},
	methods: {
		toplay(item) {
			this.videoinfo = item;
			this.isfull = false;
		},
		async getVideos() {
			const res = await this.$http.get("api/video/videoShow");
			this.videolist = res.result.videos;
			this.videoinfo = res.result;
			this.videofull = res.result;
		},
	},
};
</script>

<style lang="less" scoped>
@import url('./media.css');
.TypeShowHow {
	overflow: auto;
	.Breadcrumb {
		width: 100%;
		position: fixed;
		height: 66px;
		background: #fff1d1;
		padding-left: 38px;
		display: flex;
		justify-content: start;
		z-index: 10;
		> img {
			width: 66px;
			height: 66px;
		}
		a {
			line-height: 66px;
			font-size: 25px;
			font-weight: 400;
			color: rgba(0, 0, 0, 0.45);
		}
		a.active {
			color: #ffa216;
		}
	}
	.contain {
		max-width: 1745px;
		margin: 0 auto;
		margin-top: 66px;
		display: flex;
		justify-content: space-between;
        padding: 0 20px;
		.containl {
			// width: 40%;
			// height: 717px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			margin-top: 88px;
			video {
				width: 100%;
				// height: 615px;
			}
		}
		p.desc {
			margin-top: 20px;
			font-size: 22px;
			font-weight: 400;
			line-height: 22px;
			color: #313131;
			opacity: 0.5;
			word-break: break-all;
		}
		h1.title {
			font-size: 40px;
			font-weight: bold;
			color: #313131;
			line-height: 60px;
			overflow: hidden;
			/* white-space: nowrap; */
			text-overflow: ellipsis;
			-webkit-line-clamp: 1;
			word-break: break-all;
			display: -webkit-box;
			-webkit-box-orient: vertical;
		}
		.title {
			font-size: 30px;
			font-weight: 400;
			color: #313131;
			line-height: 50px;
		}
        .videoList {
            height:400px;
            overflow:auto;
        }
		.titledesc {
			font-size: 22px;
			font-weight: 400;
			line-height: 40px;
			color: #313131;
			opacity: 0.5;
			overflow: hidden;
			/* white-space: nowrap; */
			text-overflow: ellipsis;
			-webkit-line-clamp: 2;
			word-break: break-all;
			display: -webkit-box;
			-webkit-box-orient: vertical;
		}
		.sidearea {
			margin-top: 88px;
			> div {
				// width: 550px;
				border: 1px solid #3131314d;
				border-radius: 5px;
				margin-bottom: 22px;
				padding: 13px 16px;
				p {
					margin-bottom: 10px;
				}
				.chapter {
					font-weight: 400;
					color: #313131;
					line-height: 46px;
					font-weight: 400;
					font-size: 22px;
					display: flex;
					align-items: center;
					img {
						margin-right: 10px;
						width: 26px;
						height: 26px;
					}
				}
				.chapter:hover {
					cursor: pointer;
				}
				.active {
					padding-left: 17px;
					background: #fff1d1;
				}
			}
		}
	}
}
</style>
